import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcChangeWindowNotifications = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4.5 5A1.5 1.5 0 0 1 6 3.5h13A3.5 3.5 0 0 1 22.5 7v10a1.5 1.5 0 0 1-1.5 1.5h-.15a.35.35 0 0 1-.35-.35V7.5a2 2 0 0 0-2-2H4.85a.35.35 0 0 1-.35-.35V5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.5 7A1.5 1.5 0 0 0 2 8.5v11A1.5 1.5 0 0 0 3.5 21h14a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 17.5 7h-14Zm1.25 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8.5 2.5H3.75v7.25h13.5V12Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcChangeWindowNotifications");

export { IcChangeWindowNotifications };
//# sourceMappingURL=ic-change-window-notifications.js.map
